
export default {
    name: "addCost",
    conditionData:'',
    data() {
        return {
            costForm: {
                portName: '',
                amount: undefined,
                isDefault: ''
            },
            portNameDis: false
        }
    },
    mounted: function () {
    },
    created() {
        this.conditionData = this.$routerUtil.getParam();
    },
    computed: {
        rules() {
            return {
                portName: [
                    {required: true, message: this.$t('p_addCost.message.portName'), trigger: 'blur'},
                    {max: 100, message: this.$t('p_addCost.message.tooLong') + 100, trigger: 'blur'}
                ],
                isDefault: [
                    {required: true, message: this.$t('p_addCost.message.isDefault'), trigger: 'change'}
                ],
                amount: [
                    {required: true, message: this.$t('p_addCost.message.amount'), trigger: 'blur'}
                ]
            }
        },
    },
    methods: {
        submitForm(formName) {
            console.log(this.$refs[formName], this.$refs);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const param = Object.assign({}, param, this.costForm);
                    this.$axios.post('/api/cost/insertcost', param).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.back();
                        }
                        this.$message({
                            message: this.$t(response.data.message),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }
            });
        },
        back() {
            this.$routerUtil.setParam(this.conditionData.searchForm);
            this.$router.back();
        },
        doReset(formName){
            this.$refs[formName].resetFields();
        },
        // 是否默认发生改变
        isDefaultChange(val) {
            console.log(val);
            if (val === 1) {
                this.portNameDis = true;
                this.costForm.portName = this.$t('p_addCost.default')
            } else {
                this.portNameDis = false;
                this.costForm.portName = ''
            }
        }
    }
}
